var _g, _g2, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDeck12(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: 0,
    y: 0,
    width: 1079,
    height: 238,
    viewBox: "0, 0, 1079, 238",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Background"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1079,
    height: 238,
    fill: "#000000",
    fillOpacity: 0
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Background",
    display: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1079,0 L1079,238 L0,238 z",
    fill: "#FFFFFF"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "FPSO_FRAMING_LAYOUT"
  }, /*#__PURE__*/React.createElement("g", {
    id: "T/Deck/zijdong-Copy-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M238.932,28.262 L127.084,28.262 L127.084,11.321 L222.31,2.174 L222.31,16.621 C221.097,18.644 223.292,21.09 228.898,23.959 C234.503,26.828 237.848,28.262 238.932,28.262 z",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.932,28.262 L127.084,28.262 L127.084,11.321 L222.31,2.174 L222.31,16.621 C221.097,18.644 223.292,21.09 228.898,23.959 C234.503,26.828 237.848,28.262 238.932,28.262 z",
    fillOpacity: 0,
    stroke: "#979797",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M222.31,16.621 L127.084,28.262 L127.084,22.441 L212.68,15.218 L212.68,8.532 L127.084,15.218",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.31,16.621 L127.084,28.262 L127.084,22.441 L212.68,15.218 L212.68,8.532 L127.084,15.218",
    fillOpacity: 0,
    stroke: "#979797",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Oval"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M200.393,25.778 C200.393,26.867 201.275,27.75 202.364,27.75 C203.454,27.75 204.336,26.867 204.336,25.778 C204.336,24.69 203.454,23.807 202.364,23.807 C201.275,23.807 200.393,24.69 200.393,25.778 z",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.393,25.778 C200.393,26.867 201.275,27.75 202.364,27.75 C203.454,27.75 204.336,26.867 204.336,25.778 C204.336,24.69 203.454,23.807 202.364,23.807 C201.275,23.807 200.393,24.69 200.393,25.778 z",
    fillOpacity: 0,
    stroke: "#979797",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Oval-Copy-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M190.512,13.585 C190.647,15.123 192.003,16.261 193.541,16.127 C195.079,15.992 196.217,14.636 196.083,13.098 C195.948,11.56 194.592,10.423 193.054,10.557 C191.516,10.692 190.378,12.048 190.512,13.585 z",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.512,13.585 C190.647,15.123 192.003,16.261 193.541,16.127 C195.079,15.992 196.217,14.636 196.083,13.098 C195.948,11.56 194.592,10.423 193.054,10.557 C191.516,10.692 190.378,12.048 190.512,13.585 z",
    fillOpacity: 0,
    stroke: "#979797",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Oval-Copy-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M179.568,14.543 C179.702,16.081 181.059,17.219 182.597,17.084 C184.135,16.949 185.273,15.594 185.138,14.056 C185.004,12.518 183.648,11.38 182.11,11.515 C180.571,11.649 179.433,13.005 179.568,14.543 z",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.568,14.543 C179.702,16.081 181.059,17.219 182.597,17.084 C184.135,16.949 185.273,15.594 185.138,14.056 C185.004,12.518 183.648,11.38 182.11,11.515 C180.571,11.649 179.433,13.005 179.568,14.543 z",
    fillOpacity: 0,
    stroke: "#979797",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Oval-Copy-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M168.624,15.5 C168.758,17.038 170.114,18.176 171.652,18.042 C173.191,17.907 174.329,16.551 174.194,15.013 C174.059,13.475 172.703,12.338 171.165,12.472 C169.627,12.607 168.489,13.963 168.624,15.5 z",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.624,15.5 C168.758,17.038 170.114,18.176 171.652,18.042 C173.191,17.907 174.329,16.551 174.194,15.013 C174.059,13.475 172.703,12.338 171.165,12.472 C169.627,12.607 168.489,13.963 168.624,15.5 z",
    fillOpacity: 0,
    stroke: "#979797",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Oval-Copy-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M157.679,16.458 C157.814,17.996 159.17,19.134 160.708,18.999 C162.246,18.864 163.384,17.509 163.25,15.971 C163.115,14.433 161.759,13.295 160.221,13.43 C158.683,13.564 157.545,14.92 157.679,16.458 z",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.679,16.458 C157.814,17.996 159.17,19.134 160.708,18.999 C162.246,18.864 163.384,17.509 163.25,15.971 C163.115,14.433 161.759,13.295 160.221,13.43 C158.683,13.564 157.545,14.92 157.679,16.458 z",
    fillOpacity: 0,
    stroke: "#979797",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Oval-Copy-6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M146.735,17.415 C146.869,18.953 148.226,20.091 149.764,19.957 C151.302,19.822 152.44,18.466 152.305,16.928 C152.171,15.39 150.815,14.253 149.276,14.387 C147.738,14.522 146.6,15.878 146.735,17.415 z",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.735,17.415 C146.869,18.953 148.226,20.091 149.764,19.957 C151.302,19.822 152.44,18.466 152.305,16.928 C152.171,15.39 150.815,14.253 149.276,14.387 C147.738,14.522 146.6,15.878 146.735,17.415 z",
    fillOpacity: 0,
    stroke: "#979797",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Oval-Copy-7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M135.791,18.373 C135.925,19.911 137.281,21.049 138.819,20.914 C140.358,20.779 141.496,19.424 141.361,17.886 C141.226,16.348 139.87,15.21 138.332,15.345 C136.794,15.479 135.656,16.835 135.791,18.373 z",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.791,18.373 C135.925,19.911 137.281,21.049 138.819,20.914 C140.358,20.779 141.496,19.424 141.361,17.886 C141.226,16.348 139.87,15.21 138.332,15.345 C136.794,15.479 135.656,16.835 135.791,18.373 z",
    fillOpacity: 0,
    stroke: "#979797",
    strokeWidth: 1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-Copy"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0.923,172.953 L47.105,157.054 L62.544,201.883 L16.361,217.783 L0.923,172.953 z",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.923,172.953 L47.105,157.054 L62.544,201.883 L16.361,217.783 L0.923,172.953 z",
    fillOpacity: 0,
    stroke: "#979797",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path-3-Copy-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.681,180.521 C12.586,175.52 17.894,172.09 24.606,170.233 C31.318,168.377 36.821,168.377 41.116,170.233 C37.436,174.644 33.449,177.665 29.154,179.295 C24.859,180.926 18.034,181.335 8.681,180.521 z",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.681,180.521 C12.586,175.52 17.894,172.09 24.606,170.233 C31.318,168.377 36.821,168.377 41.116,170.233 C37.436,174.644 33.449,177.665 29.154,179.295 C24.859,180.926 18.034,181.335 8.681,180.521 z",
    fillOpacity: 0,
    stroke: "#979797",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path-3-Copy-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.377,193.336 C18.282,188.335 23.59,184.905 30.303,183.049 C37.015,181.192 42.518,181.192 46.812,183.049 C43.133,187.459 39.146,190.48 34.85,192.11 C30.555,193.741 23.731,194.15 14.377,193.336 z",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.377,193.336 C18.282,188.335 23.59,184.905 30.303,183.049 C37.015,181.192 42.518,181.192 46.812,183.049 C43.133,187.459 39.146,190.48 34.85,192.11 C30.555,193.741 23.731,194.15 14.377,193.336 z",
    fillOpacity: 0,
    stroke: "#979797",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path-3-Copy-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.074,206.151 C23.978,201.15 29.287,197.72 35.999,195.864 C42.711,194.007 48.214,194.007 52.508,195.864 C48.829,200.274 44.842,203.295 40.547,204.925 C36.251,206.556 29.427,206.965 20.074,206.151 z",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.074,206.151 C23.978,201.15 29.287,197.72 35.999,195.864 C42.711,194.007 48.214,194.007 52.508,195.864 C48.829,200.274 44.842,203.295 40.547,204.925 C36.251,206.556 29.427,206.965 20.074,206.151 z",
    fillOpacity: 0,
    stroke: "#979797",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "T/Deck/zijdong"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M900.409,29.262 L1012.256,29.262 L1012.256,12.321 L917.031,3.174 L917.031,17.621 C918.244,19.644 916.048,22.09 910.443,24.959 C904.838,27.828 901.493,29.262 900.409,29.262 z",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M900.409,29.262 L1012.256,29.262 L1012.256,12.321 L917.031,3.174 L917.031,17.621 C918.244,19.644 916.048,22.09 910.443,24.959 C904.838,27.828 901.493,29.262 900.409,29.262 z",
    fillOpacity: 0,
    stroke: "#979797",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M917.031,17.621 L1012.256,29.262 L1012.256,23.441 L926.661,16.218 L926.661,9.532 L1012.256,16.218",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M917.031,17.621 L1012.256,29.262 L1012.256,23.441 L926.661,16.218 L926.661,9.532 L1012.256,16.218",
    fillOpacity: 0,
    stroke: "#979797",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Oval"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M938.948,26.778 C938.948,27.867 938.065,28.75 936.976,28.75 C935.887,28.75 935.004,27.867 935.004,26.778 C935.004,25.69 935.887,24.807 936.976,24.807 C938.065,24.807 938.948,25.69 938.948,26.778 z",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M938.948,26.778 C938.948,27.867 938.065,28.75 936.976,28.75 C935.887,28.75 935.004,27.867 935.004,26.778 C935.004,25.69 935.887,24.807 936.976,24.807 C938.065,24.807 938.948,25.69 938.948,26.778 z",
    fillOpacity: 0,
    stroke: "#979797",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Oval-Copy-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M948.829,14.585 C948.694,16.123 947.338,17.261 945.8,17.127 C944.262,16.992 943.124,15.636 943.258,14.098 C943.393,12.56 944.749,11.423 946.287,11.557 C947.825,11.692 948.963,13.048 948.829,14.585 z",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M948.829,14.585 C948.694,16.123 947.338,17.261 945.8,17.127 C944.262,16.992 943.124,15.636 943.258,14.098 C943.393,12.56 944.749,11.423 946.287,11.557 C947.825,11.692 948.963,13.048 948.829,14.585 z",
    fillOpacity: 0,
    stroke: "#979797",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Oval-Copy-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M959.773,15.543 C959.638,17.081 958.282,18.219 956.744,18.084 C955.206,17.949 954.068,16.594 954.203,15.056 C954.337,13.518 955.693,12.38 957.231,12.515 C958.77,12.649 959.908,14.005 959.773,15.543 z",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M959.773,15.543 C959.638,17.081 958.282,18.219 956.744,18.084 C955.206,17.949 954.068,16.594 954.203,15.056 C954.337,13.518 955.693,12.38 957.231,12.515 C958.77,12.649 959.908,14.005 959.773,15.543 z",
    fillOpacity: 0,
    stroke: "#979797",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Oval-Copy-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M970.717,16.5 C970.583,18.038 969.227,19.176 967.688,19.042 C966.15,18.907 965.012,17.551 965.147,16.013 C965.281,14.475 966.637,13.338 968.176,13.472 C969.714,13.607 970.852,14.963 970.717,16.5 z",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M970.717,16.5 C970.583,18.038 969.227,19.176 967.688,19.042 C966.15,18.907 965.012,17.551 965.147,16.013 C965.281,14.475 966.637,13.338 968.176,13.472 C969.714,13.607 970.852,14.963 970.717,16.5 z",
    fillOpacity: 0,
    stroke: "#979797",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Oval-Copy-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M981.662,17.458 C981.527,18.996 980.171,20.134 978.633,19.999 C977.095,19.864 975.957,18.509 976.091,16.971 C976.226,15.433 977.582,14.295 979.12,14.43 C980.658,14.564 981.796,15.92 981.662,17.458 z",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M981.662,17.458 C981.527,18.996 980.171,20.134 978.633,19.999 C977.095,19.864 975.957,18.509 976.091,16.971 C976.226,15.433 977.582,14.295 979.12,14.43 C980.658,14.564 981.796,15.92 981.662,17.458 z",
    fillOpacity: 0,
    stroke: "#979797",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Oval-Copy-6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M992.606,18.415 C992.471,19.953 991.115,21.091 989.577,20.957 C988.039,20.822 986.901,19.466 987.036,17.928 C987.17,16.39 988.526,15.253 990.064,15.387 C991.603,15.522 992.74,16.878 992.606,18.415 z",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M992.606,18.415 C992.471,19.953 991.115,21.091 989.577,20.957 C988.039,20.822 986.901,19.466 987.036,17.928 C987.17,16.39 988.526,15.253 990.064,15.387 C991.603,15.522 992.74,16.878 992.606,18.415 z",
    fillOpacity: 0,
    stroke: "#979797",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Oval-Copy-7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1003.55,19.373 C1003.416,20.911 1002.06,22.049 1000.521,21.914 C998.983,21.779 997.845,20.424 997.98,18.886 C998.114,17.348 999.47,16.21 1001.009,16.345 C1002.547,16.479 1003.685,17.835 1003.55,19.373 z",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1003.55,19.373 C1003.416,20.911 1002.06,22.049 1000.521,21.914 C998.983,21.779 997.845,20.424 997.98,18.886 C998.114,17.348 999.47,16.21 1001.009,16.345 C1002.547,16.479 1003.685,17.835 1003.55,19.373 z",
    fillOpacity: 0,
    stroke: "#979797",
    strokeWidth: 1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "T/Deck/zijdong-Copy"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M905.907,211.086 L1017.754,211.086 L1017.754,228.028 L922.529,237.174 L922.529,222.728 C923.742,220.705 921.546,218.259 915.941,215.39 C910.336,212.521 906.991,211.086 905.907,211.086 z",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M905.907,211.086 L1017.754,211.086 L1017.754,228.028 L922.529,237.174 L922.529,222.728 C923.742,220.705 921.546,218.259 915.941,215.39 C910.336,212.521 906.991,211.086 905.907,211.086 z",
    fillOpacity: 0,
    stroke: "#979797",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M922.529,222.728 L1017.754,211.086 L1017.754,216.907 L932.159,224.13 L932.159,230.817 L1017.754,224.13",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M922.529,222.728 L1017.754,211.086 L1017.754,216.907 L932.159,224.13 L932.159,230.817 L1017.754,224.13",
    fillOpacity: 0,
    stroke: "#979797",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Oval"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M944.446,213.57 C944.446,212.481 943.563,211.599 942.474,211.599 C941.385,211.599 940.502,212.481 940.502,213.57 C940.502,214.659 941.385,215.542 942.474,215.542 C943.563,215.542 944.446,214.659 944.446,213.57 z",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M944.446,213.57 C944.446,212.481 943.563,211.599 942.474,211.599 C941.385,211.599 940.502,212.481 940.502,213.57 C940.502,214.659 941.385,215.542 942.474,215.542 C943.563,215.542 944.446,214.659 944.446,213.57 z",
    fillOpacity: 0,
    stroke: "#979797",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Oval-Copy-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M954.327,225.763 C954.192,224.225 952.836,223.087 951.298,223.222 C949.76,223.357 948.622,224.712 948.756,226.25 C948.891,227.788 950.247,228.926 951.785,228.791 C953.323,228.657 954.461,227.301 954.327,225.763 z",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M954.327,225.763 C954.192,224.225 952.836,223.087 951.298,223.222 C949.76,223.357 948.622,224.712 948.756,226.25 C948.891,227.788 950.247,228.926 951.785,228.791 C953.323,228.657 954.461,227.301 954.327,225.763 z",
    fillOpacity: 0,
    stroke: "#979797",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Oval-Copy-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M965.271,224.806 C965.136,223.268 963.78,222.13 962.242,222.265 C960.704,222.399 959.566,223.755 959.701,225.293 C959.835,226.831 961.191,227.969 962.729,227.834 C964.268,227.699 965.406,226.344 965.271,224.806 z",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M965.271,224.806 C965.136,223.268 963.78,222.13 962.242,222.265 C960.704,222.399 959.566,223.755 959.701,225.293 C959.835,226.831 961.191,227.969 962.729,227.834 C964.268,227.699 965.406,226.344 965.271,224.806 z",
    fillOpacity: 0,
    stroke: "#979797",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Oval-Copy-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M976.215,223.848 C976.081,222.31 974.725,221.172 973.186,221.307 C971.648,221.442 970.51,222.797 970.645,224.335 C970.779,225.873 972.135,227.011 973.674,226.876 C975.212,226.742 976.35,225.386 976.215,223.848 z",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M976.215,223.848 C976.081,222.31 974.725,221.172 973.186,221.307 C971.648,221.442 970.51,222.797 970.645,224.335 C970.779,225.873 972.135,227.011 973.674,226.876 C975.212,226.742 976.35,225.386 976.215,223.848 z",
    fillOpacity: 0,
    stroke: "#979797",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Oval-Copy-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M987.16,222.891 C987.025,221.353 985.669,220.215 984.131,220.35 C982.593,220.484 981.455,221.84 981.589,223.378 C981.724,224.916 983.08,226.054 984.618,225.919 C986.156,225.784 987.294,224.428 987.16,222.891 z",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M987.16,222.891 C987.025,221.353 985.669,220.215 984.131,220.35 C982.593,220.484 981.455,221.84 981.589,223.378 C981.724,224.916 983.08,226.054 984.618,225.919 C986.156,225.784 987.294,224.428 987.16,222.891 z",
    fillOpacity: 0,
    stroke: "#979797",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Oval-Copy-6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M998.104,221.933 C997.969,220.395 996.613,219.257 995.075,219.392 C993.537,219.527 992.399,220.882 992.534,222.42 C992.668,223.958 994.024,225.096 995.562,224.961 C997.101,224.827 998.238,223.471 998.104,221.933 z",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M998.104,221.933 C997.969,220.395 996.613,219.257 995.075,219.392 C993.537,219.527 992.399,220.882 992.534,222.42 C992.668,223.958 994.024,225.096 995.562,224.961 C997.101,224.827 998.238,223.471 998.104,221.933 z",
    fillOpacity: 0,
    stroke: "#979797",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Oval-Copy-7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1009.048,220.976 C1008.914,219.438 1007.558,218.3 1006.019,218.434 C1004.481,218.569 1003.343,219.925 1003.478,221.463 C1003.612,223.001 1004.968,224.139 1006.507,224.004 C1008.045,223.869 1009.183,222.513 1009.048,220.976 z",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1009.048,220.976 C1008.914,219.438 1007.558,218.3 1006.019,218.434 C1004.481,218.569 1003.343,219.925 1003.478,221.463 C1003.612,223.001 1004.968,224.139 1006.507,224.004 C1008.045,223.869 1009.183,222.513 1009.048,220.976 z",
    fillOpacity: 0,
    stroke: "#979797",
    strokeWidth: 1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "T/Deck/zijdong-Copy-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M238.932,210.388 L127.084,210.388 L127.084,227.329 L222.31,236.476 L222.31,222.029 C221.097,220.006 223.292,217.56 228.898,214.691 C234.503,211.822 237.848,210.388 238.932,210.388 z",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.932,210.388 L127.084,210.388 L127.084,227.329 L222.31,236.476 L222.31,222.029 C221.097,220.006 223.292,217.56 228.898,214.691 C234.503,211.822 237.848,210.388 238.932,210.388 z",
    fillOpacity: 0,
    stroke: "#979797",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M222.31,222.029 L127.084,210.388 L127.084,216.208 L212.68,223.432 L212.68,230.118 L127.084,223.432",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.31,222.029 L127.084,210.388 L127.084,216.208 L212.68,223.432 L212.68,230.118 L127.084,223.432",
    fillOpacity: 0,
    stroke: "#979797",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Oval"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M200.393,212.871 C200.393,211.783 201.275,210.9 202.364,210.9 C203.454,210.9 204.336,211.783 204.336,212.871 C204.336,213.96 203.454,214.843 202.364,214.843 C201.275,214.843 200.393,213.96 200.393,212.871 z",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.393,212.871 C200.393,211.783 201.275,210.9 202.364,210.9 C203.454,210.9 204.336,211.783 204.336,212.871 C204.336,213.96 203.454,214.843 202.364,214.843 C201.275,214.843 200.393,213.96 200.393,212.871 z",
    fillOpacity: 0,
    stroke: "#979797",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Oval-Copy-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M190.512,225.064 C190.647,223.526 192.003,222.389 193.541,222.523 C195.079,222.658 196.217,224.014 196.083,225.552 C195.948,227.09 194.592,228.227 193.054,228.093 C191.516,227.958 190.378,226.602 190.512,225.064 z",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.512,225.064 C190.647,223.526 192.003,222.389 193.541,222.523 C195.079,222.658 196.217,224.014 196.083,225.552 C195.948,227.09 194.592,228.227 193.054,228.093 C191.516,227.958 190.378,226.602 190.512,225.064 z",
    fillOpacity: 0,
    stroke: "#979797",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Oval-Copy-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M179.568,224.107 C179.702,222.569 181.059,221.431 182.597,221.566 C184.135,221.7 185.273,223.056 185.138,224.594 C185.004,226.132 183.648,227.27 182.11,227.135 C180.571,227.001 179.433,225.645 179.568,224.107 z",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.568,224.107 C179.702,222.569 181.059,221.431 182.597,221.566 C184.135,221.7 185.273,223.056 185.138,224.594 C185.004,226.132 183.648,227.27 182.11,227.135 C180.571,227.001 179.433,225.645 179.568,224.107 z",
    fillOpacity: 0,
    stroke: "#979797",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Oval-Copy-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M168.624,223.149 C168.758,221.611 170.114,220.474 171.652,220.608 C173.191,220.743 174.329,222.099 174.194,223.637 C174.059,225.175 172.703,226.312 171.165,226.178 C169.627,226.043 168.489,224.687 168.624,223.149 z",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.624,223.149 C168.758,221.611 170.114,220.474 171.652,220.608 C173.191,220.743 174.329,222.099 174.194,223.637 C174.059,225.175 172.703,226.312 171.165,226.178 C169.627,226.043 168.489,224.687 168.624,223.149 z",
    fillOpacity: 0,
    stroke: "#979797",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Oval-Copy-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M157.679,222.192 C157.814,220.654 159.17,219.516 160.708,219.651 C162.246,219.785 163.384,221.141 163.25,222.679 C163.115,224.217 161.759,225.355 160.221,225.22 C158.683,225.086 157.545,223.73 157.679,222.192 z",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.679,222.192 C157.814,220.654 159.17,219.516 160.708,219.651 C162.246,219.785 163.384,221.141 163.25,222.679 C163.115,224.217 161.759,225.355 160.221,225.22 C158.683,225.086 157.545,223.73 157.679,222.192 z",
    fillOpacity: 0,
    stroke: "#979797",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Oval-Copy-6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M146.735,221.234 C146.869,219.696 148.226,218.559 149.764,218.693 C151.302,218.828 152.44,220.184 152.305,221.722 C152.171,223.26 150.815,224.397 149.276,224.263 C147.738,224.128 146.6,222.772 146.735,221.234 z",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.735,221.234 C146.869,219.696 148.226,218.559 149.764,218.693 C151.302,218.828 152.44,220.184 152.305,221.722 C152.171,223.26 150.815,224.397 149.276,224.263 C147.738,224.128 146.6,222.772 146.735,221.234 z",
    fillOpacity: 0,
    stroke: "#979797",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Oval-Copy-7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M135.791,220.277 C135.925,218.739 137.281,217.601 138.819,217.736 C140.358,217.87 141.496,219.226 141.361,220.764 C141.226,222.302 139.87,223.44 138.332,223.305 C136.794,223.171 135.656,221.815 135.791,220.277 z",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.791,220.277 C135.925,218.739 137.281,217.601 138.819,217.736 C140.358,217.87 141.496,219.226 141.361,220.764 C141.226,222.302 139.87,223.44 138.332,223.305 C136.794,223.171 135.656,221.815 135.791,220.277 z",
    fillOpacity: 0,
    stroke: "#979797",
    strokeWidth: 1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "T/Deck"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-Copy-19"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.015,30.548 L1025.829,30.548 C1051.177,30.548 1071.726,48.456 1071.726,70.548 L1071.726,168.9 C1071.726,190.991 1051.177,208.9 1025.829,208.9 L59.015,208.9 C33.667,208.9 13.118,190.991 13.118,168.9 L13.118,70.548 C13.118,48.456 33.667,30.548 59.015,30.548 z",
    fill: "#EDEEF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.015,30.548 L1025.829,30.548 C1051.177,30.548 1071.726,48.456 1071.726,70.548 L1071.726,168.9 C1071.726,190.991 1051.177,208.9 1025.829,208.9 L59.015,208.9 C33.667,208.9 13.118,190.991 13.118,168.9 L13.118,70.548 C13.118,48.456 33.667,30.548 59.015,30.548 z",
    fillOpacity: 0,
    stroke: "#8993A4",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", {
    id: "T/Deck/Piping",
    opacity: 0.548
  }, /*#__PURE__*/React.createElement("path", {
    d: "M197.923,106.567 L1046.3,106.567 C1052.004,106.567 1056.627,110.596 1056.627,115.567 L1056.627,119.495 C1056.627,124.466 1052.004,128.495 1046.3,128.495 L197.923,128.495 C192.219,128.495 187.596,124.466 187.596,119.495 L187.596,115.567 C187.596,110.596 192.219,106.567 197.923,106.567 z",
    fillOpacity: 0,
    stroke: "#FFEE00",
    strokeWidth: 3,
    id: "Rectangle-Copy-27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.178,113.876 L1042.367,113.876 C1044.683,113.876 1046.561,115.512 1046.561,117.531 L1046.561,117.531 C1046.561,119.549 1044.683,121.186 1042.367,121.186 L200.178,121.186 C197.862,121.186 195.984,119.549 195.984,117.531 L195.984,117.531 C195.984,115.512 197.862,113.876 200.178,113.876 z",
    fillOpacity: 0,
    stroke: "#FFEE00",
    strokeWidth: 3,
    id: "Rectangle-Copy-28"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-Copy"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M83.667,50.552 L132.146,50.552 C133.413,50.552 134.441,51.448 134.441,52.552 L134.441,186.895 C134.441,188 133.413,188.895 132.146,188.895 L83.667,188.895 C82.4,188.895 81.372,188 81.372,186.895 L81.372,52.552 C81.372,51.448 82.4,50.552 83.667,50.552 z",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.667,50.552 L132.146,50.552 C133.413,50.552 134.441,51.448 134.441,52.552 L134.441,186.895 C134.441,188 133.413,188.895 132.146,188.895 L83.667,188.895 C82.4,188.895 81.372,188 81.372,186.895 L81.372,52.552 C81.372,51.448 82.4,50.552 83.667,50.552 z",
    fillOpacity: 0,
    stroke: "#979797",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Polygon-Copy"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M82.595,15.421 C82.899,15.421 83.191,15.526 83.406,15.714 L83.406,15.714 L104.76,34.322 C104.976,34.509 105.096,34.764 105.096,35.029 L105.096,35.029 L105.096,61.344 C105.096,61.609 104.976,61.864 104.76,62.051 L104.76,62.051 L83.406,80.659 C83.191,80.847 82.899,80.952 82.595,80.952 L82.595,80.952 L52.395,80.952 C52.091,80.952 51.799,80.847 51.584,80.659 L51.584,80.659 L30.229,62.051 C30.014,61.864 29.893,61.609 29.893,61.344 L29.893,61.344 L29.893,35.029 C29.893,34.764 30.014,34.509 30.229,34.322 L30.229,34.322 L51.584,15.714 C51.799,15.526 52.091,15.421 52.395,15.421 L52.395,15.421 z",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.595,15.421 C82.899,15.421 83.191,15.526 83.406,15.714 L83.406,15.714 L104.76,34.322 C104.976,34.509 105.096,34.764 105.096,35.029 L105.096,35.029 L105.096,61.344 C105.096,61.609 104.976,61.864 104.76,62.051 L104.76,62.051 L83.406,80.659 C83.191,80.847 82.899,80.952 82.595,80.952 L82.595,80.952 L52.395,80.952 C52.091,80.952 51.799,80.847 51.584,80.659 L51.584,80.659 L30.229,62.051 C30.014,61.864 29.893,61.609 29.893,61.344 L29.893,61.344 L29.893,35.029 C29.893,34.764 30.014,34.509 30.229,34.322 L30.229,34.322 L51.584,15.714 C51.799,15.526 52.091,15.421 52.395,15.421 L52.395,15.421 z",
    fillOpacity: 0,
    stroke: "#979797",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "T/hel"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.493,50.151 C58.39,50.061 58.341,49.961 58.345,49.849 C58.349,49.738 58.402,49.638 58.504,49.549 L68.462,40.87 C68.574,40.773 68.694,40.722 68.822,40.718 C68.95,40.715 69.065,40.758 69.168,40.848 L69.91,41.495 C70.024,41.593 70.081,41.701 70.082,41.817 C70.083,41.933 70.027,42.039 69.916,42.137 L65.676,45.832 L71.057,50.522 L75.297,46.827 C75.409,46.729 75.531,46.681 75.664,46.682 C75.797,46.683 75.916,46.728 76.019,46.818 L76.761,47.465 C76.874,47.564 76.931,47.671 76.932,47.787 C76.933,47.903 76.878,48.01 76.766,48.107 L66.808,56.786 C66.706,56.875 66.586,56.916 66.448,56.911 C66.31,56.906 66.189,56.858 66.086,56.768 L65.344,56.121 C65.241,56.032 65.189,55.929 65.188,55.813 C65.187,55.697 65.237,55.594 65.339,55.506 L69.731,51.678 L64.349,46.988 L59.957,50.816 C59.856,50.904 59.736,50.946 59.597,50.941 C59.459,50.935 59.339,50.888 59.235,50.798 L58.493,50.151 z",
    fill: "#2F2F2F",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.507,58.29 C72.507,63.518 62.78,63.517 56.78,58.288 C50.78,53.059 50.779,44.582 56.778,39.353 C62.778,34.125 72.505,34.125 78.505,39.355 C84.505,44.584 84.506,53.061 78.507,58.29 z",
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    id: "Oval"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Path-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1017.736,21.711 C1057.063,25.52 1076.726,41.981 1076.726,71.094 C1076.726,114.763 1076.726,132.253 1076.726,175.186 C1076.726,203.808 1058.938,219.983 1023.361,223.711 L1023.361,195.89 L1033.342,183.597 L1033.342,156.201 L1038.816,146.82 L1038.816,99.496 L1033.342,90.114 L1033.342,60.348 L1023.361,48.697 L1023.361,30.269 L1017.736,30.269 L1017.736,21.711 z",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1017.736,21.711 C1057.063,25.52 1076.726,41.981 1076.726,71.094 C1076.726,114.763 1076.726,132.253 1076.726,175.186 C1076.726,203.808 1058.938,219.983 1023.361,223.711 L1023.361,195.89 L1033.342,183.597 L1033.342,156.201 L1038.816,146.82 L1038.816,99.496 L1033.342,90.114 L1033.342,60.348 L1023.361,48.697 L1023.361,30.269 L1017.736,30.269 L1017.736,21.711 z",
    fillOpacity: 0,
    stroke: "#979797",
    strokeWidth: 1
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeck12);
export default __webpack_public_path__ + "static/media/deck12.7aaea6e3.svg";
export { ForwardRef as ReactComponent };